import { render, staticRenderFns } from "./SkillStatements.vue?vue&type=template&id=abbee28e&scoped=true"
import script from "./SkillStatements.vue?vue&type=script&lang=js"
export * from "./SkillStatements.vue?vue&type=script&lang=js"
import style0 from "./SkillStatements.vue?vue&type=style&index=0&id=abbee28e&prod&scoped=true&lang=scss"
import style1 from "./SkillStatements.vue?vue&type=style&index=1&id=abbee28e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbee28e",
  null
  
)

export default component.exports